export default __webpack_public_path__ + "static/media/test5.bb8255b9.jpg";